<template>
    <div>
        <RejillaZonas :dxDataSourceProp="dxDataGridSource"></RejillaZonas>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useRoute } from "vue-router";
import { useIntl } from '@services/i18n'
import type { LoadOptions } from 'devextreme/data';
import { useApi } from '@/.shared/.api/integration';
import type { ZonaDetalleModel } from '@/.shared/.api';
import type CustomStore from 'devextreme/data/custom_store';
import RejillaZonas from '@/components/zonas/RejillaZonas.vue';
import { useRouter } from '@/.shared/services/routing-services';
import type { LoadResult, LoadResultObject } from 'devextreme/common/data/custom-store';
const emit = defineEmits(['childViewLoaded']);

const api = useApi();
const intl = useIntl();
const route = useRoute();
const router = useRouter();

let dxDataGridSource: CustomStore;
const zonas = ref<ZonaDetalleModel[]>([]);

onMounted(() => {
    emit('childViewLoaded', route.name);
});

dxDataGridSource = api.apiStore({ // para rejillas
    key: 'Id',
    load: await api.toStandardApiFunction('zonaGetRejilla', {}),
    onLoaded: (result: LoadResult<ZonaDetalleModel>, loadOptions: LoadOptions<ZonaDetalleModel>) => {
        if (loadOptions.group == null) {
            zonas.value = (result as LoadResultObject<ZonaDetalleModel>).data as ZonaDetalleModel[];
        }
    }
});
</script>